<template>
    <div class="form-group" :class="col">
        <label v-if="label" :for="forId">{{label}}</label>
        <input
                :value="value"
                :name="label"
                :id="forId"
                :type="inputType"
                class="form-control"
                :class="inputClass"
                v-validate="required"
                :readonly="readonly"
                :max="max"
                @input="$emit('input', inputType === 'zipCode' ? $event.target.value.toUpperCase() : $event.target.value)">
        <span v-if="errors.first(label)" class="small text-danger">{{ errors.first(label) }}</span>
    </div>
</template>

<script>
    export default {
        inject: ['$validator'],
        props: {
            value: String,
            col: String,
            label: String,
            forId: String,
            inputType: {
                type: String,
                default: 'text'
            },
            inputClass: String,
            required: {
                type: String,
                default: ''
            },
            readonly: {
                type: Boolean,
                default: false
            },
            max: String
        },
        data() {
            return {

            }
        },
    }
</script>
